import React, { useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from '../../redux/states/appState'
import { ChatMessage } from './ChatMessage'

export const ChatMessages: React.FC = () => {
	const messages = useSelector(
		(state: AppState) => state.chatbotReducer.messages
	)
	const messagesEndRef = useRef<HTMLDivElement>(null)
	const messagesContainerRef = useRef<HTMLDivElement>(null)

	const scrollToBottom = () => {
		if (messagesContainerRef.current) {
			messagesContainerRef.current.scrollTop =
				messagesContainerRef.current.scrollHeight
		}
	}

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			scrollToBottom()
		}, 100)
		return () => clearTimeout(timeoutId)
	}, [messages])

	return (
		<div className="chat-messages" ref={messagesContainerRef}>
			{messages.map((message, index) => (
				<ChatMessage
					key={message.id}
					message={message}
					isLastMessage={index === messages.length - 1}
				/>
			))}
			<div
				ref={messagesEndRef}
				style={{ height: '20px', width: '100%' }}
			/>
		</div>
	)
}
